/**
 * useScheduleDraftDetail — ScheduleDraft 编辑工作台的草稿详情查询入口。
 *
 * 本 hook 通过 React Query 消费 Feature service，向 Context 提供当前草稿的
 * 主事实源。页面和组件不直接调用 API，而是通过这里取得可缓存、可刷新、
 * 可组合的 detail query。
 *
 * 设计文档 → docs/20_workspace_ux/28_frontend_code_map_and_data_flow.md
 * 骨架关联 → services/scheduleDraftDataService.js (HTTP 边界), hooks/queryKeys.js (缓存 key), context/ScheduleDraftEditorWorkspaceContext.jsx (组合层)
 */

import { useQuery } from "react-query";
import { scheduleDraftQueryKeys } from "./queryKeys";
import { scheduleDraftDataService } from "../services/scheduleDraftDataService";

export function useScheduleDraftDetail(draftId, options = {}) {
    return useQuery(
        scheduleDraftQueryKeys.detail(draftId),
        () => scheduleDraftDataService.getDraftDetail(draftId),
        {
            enabled: Boolean(draftId),
            staleTime: 60000,
            refetchOnWindowFocus: false,
            ...options,
        },
    );
}

export default useScheduleDraftDetail;
